export class Suburb {
  public suburbCd: string;
  public description: string;
}
